import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { getPriceCurrencyFormat } from 'src/utils/price';

const ShoppingListPriceCell = (props: GridCellProps) => {
  const intl = useInternationalization();
  const { value } = useGridCellDisplayValue(props);
  const priceFormat = useMemo(
    () => getPriceCurrencyFormat(props.dataItem?.uom),
    [props.dataItem?.uom]
  );
  const formattedPrice =
    value == null || value === '' ? '' : intl.format(priceFormat, Number(value));

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={false}
      className="!p-0 !text-right"
      title={formattedPrice}
    >
      {formattedPrice}
    </GridCellBase>
  );
};

export default ShoppingListPriceCell;
